import { Fail } from './fail';

export class ConnectionFail extends Fail {
  _message = 'Check your internet connection';
}
